/**
 * Main Entry Point
 *
 * Bootstraps the auth app which handles routing.
 * Game is loaded on demand via the /play route.
 *
 * IMPORTANT: This file must NOT import any game/engine code directly.
 * The logger from utils/logger imports gameConfig which pulls in engine code.
 * Use console.log here instead to keep the entry point lightweight.
 */

// Initialize goober FIRST (before any styled components)
import './ui/setup'

import { render } from 'preact'
import { App } from './ui/App'
import { initAuth } from './ui/store/auth'

// Dev console helpers - only load game module when explicitly called
if (import.meta.env.DEV) {
  ;(window as any).startGame = async () => {
    const { startGame } = await import('./game')
    return startGame()
  }
  ;(window as any).cleanupGame = async () => {
    const { cleanupGame } = await import('./game')
    return cleanupGame()
  }
}

/**
 * Bootstrap the application
 */
async function bootstrap() {
  console.log('[Main] Bootstrapping app...')

  // Initialize auth first (Keycloak check-sso)
  await initAuth()
  console.log('[Main] Auth initialized')

  // Mount the app
  const authRoot = document.getElementById('auth-root')
  if (!authRoot) {
    throw new Error('Missing #auth-root element in DOM')
  }

  render(<App />, authRoot)

  console.log('[Main] App mounted')
}

bootstrap().catch((error) => {
  console.error('[Main] Bootstrap failed:', error)
})
